import {
  FormControl,
  RadioGroup,
  Card,
  CardContent,
  Box,
  Typography,
  FormControlLabel,
  Radio,
  FormGroup,
  Checkbox,
  Button,
  useTheme,
} from '@mui/material';
import { PaymentMethod } from '../types';
import { t } from 'i18next';

interface IProps {
  selectedPayment: string;
  handlePaymentChange: (paymentMethod: string) => void;
  isUserTermsChecked: boolean;
  handleUserTermsChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handlePaymentNext: () => void;
}

export const SelectPayment = ({
  selectedPayment,
  handlePaymentChange,
  isUserTermsChecked,
  handleUserTermsChange,
  handlePaymentNext,
}: IProps) => {
  const theme = useTheme();
  const paymentMethods = [
    {
      id: PaymentMethod.Google,
      name: 'Google Pay',
      icon: (
        <img
          src="/images/google-pay-mark.svg"
          alt="Google Pay"
          style={{
            height: 36,
            width: 'auto',
            objectFit: 'contain',
          }}
        />
      ),
    },
    {
      id: PaymentMethod.Apple,
      name: 'Apple Pay',
      icon: (
        <img
          src="/images/apple-pay-mark.svg"
          alt="Apple Pay"
          style={{
            height: 36,
            width: 'auto',
            objectFit: 'contain',
          }}
        />
      ),
    },
    {
      id: PaymentMethod.Card,
      name: 'Credit/Debit Card',
      icon: (
        <img
          src="/images/credit-card-mark.svg"
          alt="Credit Card"
          style={{
            height: 40,
            width: 'auto',
            objectFit: 'contain',
          }}
        />
      ),
    },
  ];
  return (
    <>
      <FormControl component="fieldset" sx={{ width: '100%' }}>
        <RadioGroup
          value={selectedPayment}
          onChange={(event) => handlePaymentChange(event.target.value)}
          sx={{ gap: 2 }}
        >
          {paymentMethods.map((method) => (
            <Card
              key={method.id}
              variant="outlined"
              sx={{
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                border:
                  selectedPayment === method.id
                    ? `2px solid var(--mui-palette-primary-main, ${theme.palette.primary.light})`
                    : '1px solid #e0e0e0',
                backgroundColor:
                  selectedPayment === method.id
                    ? `var(--mui-palette-primary-main, ${theme.palette.primary.light})08`
                    : 'white',
                '&:hover': {
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  transform: 'translateY(-2px)',
                },
              }}
              onClick={() => handlePaymentChange(method.id)}
            >
              <CardContent
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  py: 2,
                }}
              >
                <Box
                  sx={{
                    mr: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 64,
                    minWidth: 64,
                  }}
                >
                  {method.icon}
                </Box>

                <Box sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ fontWeight: 'medium' }}
                  >
                    {method.name}
                  </Typography>
                </Box>

                <FormControlLabel
                  value={method.id}
                  control={
                    <Radio
                      sx={{
                        color: 'primary',
                        '&.Mui-checked': {
                          color: 'primary',
                        },
                      }}
                    />
                  }
                  label=""
                  sx={{ margin: 0 }}
                />
              </CardContent>
            </Card>
          ))}
        </RadioGroup>

        {selectedPayment && (
          <Box
            sx={{
              mt: 3,
              p: 2,
              bgcolor: '#f5f5f5',
              borderRadius: 1,
            }}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isUserTermsChecked}
                    onChange={handleUserTermsChange}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                }
                label={
                  <Typography variant="body1" color="text.secondary">
                    <span className="text-sm text-gray-700">
                      {t('acceptTerms')}
                      <br />
                    </span>
                  </Typography>
                }
              />
            </FormGroup>
          </Box>
        )}
      </FormControl>
      <Button
        variant="contained"
        type="button"
        size="large"
        onClick={handlePaymentNext}
        disabled={!isUserTermsChecked}
        sx={{ textTransform: 'none', width: '100%', mt: 2 }}
      >
        {t('continue')}
      </Button>
    </>
  );
};
